// @ts-expect-error Untyped constants
import { HAS_SEEN_BLOG_PLG_ONBOARDING_TOUR } from 'ContentEditorUI/lib/userAndLocalCacheSettings/constants';
// @ts-expect-error Untyped module settingsActions
import { setSuperstoreUserSetting } from 'ContentEditorUI/redux/actions/settingsActions';
export const setHasSeenOnboardingTour = hasSeen => setSuperstoreUserSetting(HAS_SEEN_BLOG_PLG_ONBOARDING_TOUR, hasSeen);